{
    "Umyndig.Pageheading.Engangsstonad": "Søknad om eingongsstønad",
    "Umyndig.Pageheading.Foreldrepenger": "Søknad om foreldrepengar",
    "Umyndig.Pageheading.Svangerskapspenger": "Søknad om svangerskapspenger",
    "Umyndig.Tittel": "Fordi du er under 18 år, må du senda papirsøknad",
    "Umyndig.Tekst": "Fordi du er under 18 år, må ein av foreldrene dine eller ein føresatt skrive under på søknaden din samen med deg. Derfor må du fylle ut søknaden på papir og sende den i posten til Nav.",
    "Umyndig.Knapp.Papirsøknad": "Gå til papirsøknaden",
    "ErrorSummaryFelles.Tittel": "Du må rette opp i følgjande feil:",
    "StepButtons.Forrige": "Forrige steg",
    "StepButtons.ForrigeSimple": "Forrige",
    "StepButtons.Neste": "Neste steg",
    "StepButtons.NesteSimple": "Neste",
    "StepButtons.GåTilOppsummering": "Gå til oppsummering",
    "StepButtons.GåTilOppsummeringSimple": "Oppsummering",
    "StepButtons.Send": "Send søknaden",
    "ErrorPage.Engangsstønad": "Eingongsstønad",
    "ErrorPage.Foreldrepenger": "Foreldrepengar",
    "ErrorPage.Svangerskapspenger": "Svangerskapspengar",
    "ErrorPage.Heading": "Beklager, noko har gått feil med søknaden din på grunn av ein teknisk feil hjå oss",
    "ErrorPage.Message": "Du kan venta litt og deretter prøva å søka på nytt. Dersom det fortsatt er problem kan du kontakta brukarstøtte for å få hjelp.",
    "ErrorPage.Contact": "Kontakt brukerstøtte",
    "ErrorPage.TryAgain": "Søk på nytt",
    "ErrorPage.ErrorMessage": "Feilmelding",
    "ScanDocumentInfo.Tittel": "Korleis ta bilde av eit dokument med mobilen",
    "ScanDocumentInfo.Del1": "Har du eit dokument på papir, kan du ta eit bilde av dokumentet for å sende det til oss.",
    "ScanDocumentInfo.Liste.Punkt1": "Ta bilde av dokumentet med smarttelefonen eller nettbrettet.",
    "ScanDocumentInfo.Liste.Punkt2": "Sjekk at dokumentet er lett å lese.",
    "ScanDocumentInfo.Liste.Punkt3": "Logg inn på nav.no via mobilen – last opp og legg bileta ved den elektroniske søknaden.",
    "ScanDocumentInfo.Liste.Punkt4": "Ønskjer du å bruka PC eller Mac, kan du senda bileta til den private e-postkontoen din og lagra bileta på eininga di.",
    "ScanDocumentInfo.Liste.Punkt5": "Last opp og legg bileta ved den elektroniske søknaden din.",
    "ScanDocumentInfo.Del2": "Har du skannar, kan du skanne dokument.",
    "ScanDocumentInfo.Link": "Meir informasjon om å senda vedlegg på nav.no.",
    "StepFooter.Avslutt": "Slett søknaden",
    "StepFooter.ContinueLater": "Fortsett seinare",
    "AvsluttModal.Tittel": "Avslutt",
    "AvsluttModal.Info": "Søknaden din blir sletta. Viss du skal søkje seinare, må du fylle ut frå starten.",
    "AvsluttModal.Cancel": "Avbryt",
    "AvsluttModal.Delete": "Slett søknaden",
    "FortsettSenereModal.Tittel": "Fortset seinare",
    "FortsettSenereModal.Info": "Søknaden er lagra, og du kan fullføre ho seinare. Søknaden blir lagra i ei veke.",
    "FortsettSenereModal.Ok": "Ok",
    "SimpleErrorPage.ErrorHeader": "Beklagar, det ser ut til at noko har feila grunna ein teknisk feil hjå Nav",
    "SimpleErrorPage.ErrorBody": "Du kan prøve å planlegge på nytt, og dersom du framleis får ein feil kan du vente litt og komme tilbake seinare.",
    "SimpleErrorPage.TryAgain": "Planlegg på nytt",
    "Step.HarValgfrieFelt": "Alle felt må fyllast ut, bortsett frå felt markert med (valfritt).",
    "Step.HarObligatoriskeFelt": "Alle felt må fyllast ut.",
    "FrontPage.Start": "Start",
    "RegisterdataUtdatert.Engangsstønad": "Eingongsstønad",
    "RegisterdataUtdatert.Foreldrepenger": "Foreldrepengar",
    "RegisterdataUtdatert.Svangerskapspenger": "Svangerskapspengar",
    "RegisterdataUtdatert.StartPaNytt": "Start på nytt",
    "RegisterdataUtdatert.Heading": "Opplysningar er endra",
    "RegisterdataUtdatert.Message": "Opplysningar om deg er endra sidan sist du fylte ut søknaden. Du må derfor starta utfyllinga av søknaden på nytt.",
    "ProgressStepper.ShowSteps": "Vis alle steg",
    "ProgressStepper.HideSteps": "Skjul alle steg",
    "ProgressStepper.StepCounter": "Steg {activeStep} av {totalSteps}",
    "DekningsgradUtbetalingEksempel.Tittel": "Begge alternativa gir omtrent like mykje pengar totalt",
    "DekningsgradUtbetalingEksempel.Intro": "Eksempelet under bruker ei månadslønn på 50 000 kr.",
    "DekningsgradUtbetalingEksempel.Rad.Varighet": "Varigheit:",
    "DekningsgradUtbetalingEksempel.Rad.PerMåned": "Per månad:",
    "DekningsgradUtbetalingEksempel.Rad.Totalt": "Totalt ca.:",
    "DekningsgradUtbetalingEksempel.Hundre.Tittel": "100 % utbetaling",
    "DekningsgradUtbetalingEksempel.Hundre.Varighet": "49 veker",
    "DekningsgradUtbetalingEksempel.Hundre.PerMåned": "50 000 kr",
    "DekningsgradUtbetalingEksempel.Hundre.Totalt": "565 460 kr",
    "DekningsgradUtbetalingEksempel.Atti.Tittel": "80 % utbetaling",
    "DekningsgradUtbetalingEksempel.Atti.Varighet": "61 veker + 1 dag",
    "DekningsgradUtbetalingEksempel.Atti.PerMåned": "40 000 kr",
    "DekningsgradUtbetalingEksempel.Atti.Totalt": "564 876 kr",
    "DekningsgradUtbetalingEksempel.Fotnote": "Med denne lønna er forskjellen 584 kroner. Feriepengane er også tilnærma like for begge alternativa.",
    "DekningsgradUtbetalingEksempel.Link": "Rekn ut kor mykje du kan få på nav.no"
}
